import React from "react"
import classnames from "classnames"
import styles from "./ToastPopup.less"
import CrossIcon from "../Icons/CrossIcon"
import { WINDOW } from "constants/environment"
import ButtonIcon from "../ButtonIcon/ButtonIcon"
import Visible from "../Visible/Visible"

class ToastPopup extends React.PureComponent {
  constructor(props){
    super(props)
  }
  componentDidMount() {
    setTimeout(() => {
      // if there is any other ToastPopup, first close that one
      // We can only have on ToastPopup
      // Passing uniqueID is mandatory because we need to know is it a new one or not

      if (WINDOW.ToastPopupSingleton && WINDOW.ToastPopupSingleton !== this && WINDOW.ToastPopupSingleton.props.uniqueID !== this.props.uniqueID){
        WINDOW.ToastPopupSingleton.toast && WINDOW.ToastPopupSingleton.toast.classList.remove(styles.ToastPopupVisible)
        setTimeout(() => {
          WINDOW.ToastPopupSingleton.props.onClose && WINDOW.ToastPopupSingleton.props.onClose()
          WINDOW.ToastPopupSingleton = this
        }, 100)
      }else {
        WINDOW.ToastPopupSingleton = this
      }

      this.toast && this.toast.classList.add(styles.ToastPopupVisible)
    }, 100)
  }

  _handleClose = () => {
    const { onClose = () => {} } = this.props
    this.toast && this.toast.classList.remove(styles.ToastPopupVisible)

    setTimeout(() => {
      onClose()
    }, 1000)
  }

  render() {
    return (
      <div
        ref={c => this.toast = c}
        data-test="toast-popup"
        className={classnames({
          [styles.ToastPopup]: true
        })}>
        <div className={classnames({
          [styles.ToastPopupChildren]: true
        })}>
          {this.props.children}
        </div>
        <div>
          <ButtonIcon onClick={this._handleClose} styleName='whiteColor'>
            <div className={classnames({
              [styles.ToastPopupClose]: true
            })}>
              <CrossIcon style={{
                width: "1.6em",
                height: "1.6em"
              }} />
              <Visible visible={["mobile"]}>
                <div className={classnames({
                  [styles.ToastPopupCloseText]: true
                })}>
                  close
                </div>
              </Visible>
            </div>
          </ButtonIcon>
        </div>
      </div>
    )
  }
}


export default ToastPopup



// WEBPACK FOOTER //
// ./src/AtomicComponents/ToastPopup/ToastPopup.jsx